const TPO_STATUS_DEFINITIONS_URL = '/api/admin-panel/tpo-status-definitions';

export class TpoStatusConfigurationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTpoStatusDefinitions(config) {
    return this.#http.get(TPO_STATUS_DEFINITIONS_URL, config);
  }

  async createTpoStatusDefinition(body) {
    return this.#http.post(TPO_STATUS_DEFINITIONS_URL, body);
  }

  async updateTpoStatusDefinition({ id, ...body }) {
    return this.#http.put(`${TPO_STATUS_DEFINITIONS_URL}/${id}`, body);
  }

  async deleteTpoStatusDefinition({ id }) {
    return this.#http.delete(`${TPO_STATUS_DEFINITIONS_URL}/${id}`);
  }

  async reorderTpoStatusDefinitions(body) {
    return this.#http.put(`${TPO_STATUS_DEFINITIONS_URL}/reorder`, body);
  }

  async dryRunTpoStatusDefinitions(body) {
    return this.#http.post(`${TPO_STATUS_DEFINITIONS_URL}/dry-run`, body);
  }
}
